/* eslint-disable quote-props */
/*eslint complexity: off*/
import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { CircularProgress } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import Paper from '~/components/Paper';
import { SusServiceShowForm } from './containers/SusServiceShowForm/SusServiceShowForm';

import { URL } from '~/config/uri';
import Request from '~/providers/Request';

function SusService({ clientCNS }) {
  const [susData, setSusData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [errorMessage, setErrorMessage] = React.useState('');

  useEffect(() => {
    const fn = async () => {
      try {
        const response = await fetch(
          `${URL}/admin/medical_records/cns/${clientCNS}`,
          {
            method: 'GET',
            headers: { Authorization: `Bearer ${await Request.getAuth()}` },
          }
        );
        const data = await response.json();
        if (data && data.message) {
          setErrorMessage(data.message);
        } else {
          setSusData(data);
        }
      } catch (err) {
        toast.error('Erro ao buscar dados do SUS');
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fn();
  }, [clientCNS]);

  const atendimentos = (susData && susData.atendimentos) || [];

  return (
    <>
      <Paper Icon={AssignmentIndIcon} title="Atendimento SUS"></Paper>

      {atendimentos.map((at, key) => (
        <SusServiceShowForm key={at.id || key} atendimento={at} />
      ))}

      {!loading && !errorMessage && atendimentos.length === 0 && (
        <Typography style={{ textAlign: 'center', marginTop: 16 }}>
          Nenhum atendimento encontrado no SUS para este paciente.
        </Typography>
      )}

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 12,
        }}
      >
        {loading && <CircularProgress color={'primary'} />}
        <p>{errorMessage}</p>
      </div>
    </>
  );
}

export default React.memo(SusService);
